<img id="productImage" *ngIf="imageUrl" [src]="imageUrl">Drop Image
